GP.GPMod('hotties', function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util = self.app.Util;
            _log   = self.app.Util.log;

        },
        hot_duids: [],
        minimum_required: 1,
        wink_count: 0
    };
 
    var apis = {
        get_hotties: function() {
            self.api.json('/members/user/hotties/', {
                success: function(json) {
                    events.display_hotties(json);
                }
            });
        }
    };

    var events = {
        setup_hotties_modal: function() {
            data.init();
            apis.get_hotties();

            $("#hotties-pics").delegate(".user_pic", "click", function(eventObject) {
                $(this).toggleClass('selected');
                if ($(this).hasClass('selected')) {
                    data.wink_count++;
                } else {
                    data.wink_count--;
                }
                if (data.wink_count >= data.minimum_required) {
                    $('#send_winks_button').removeClass('btn-default');
                    $('#send_winks_button').addClass('btn-primary');
                } else {
                    $('#send_winks_button').removeClass('btn-primary');
                    $('#send_winks_button').addClass('btn-default');
                }
                events.refresh_wink_number();
            });

            // hooking up the upload button
            $('#see_more_button').on('click', function(e) {
                e.preventDefault();
                events.add_duids();
                apis.get_hotties();
                events.refresh_wink_number();
            });

            $("#send_winks_button").on('click', function(e) {
                if (data.wink_count >= data.minimum_required) {
                    events.add_duids();
                    events.send_winks();
                    $('#fl-modal').modal('hide');
                }
            });

            _util.set_cookie('fl_hotwinks', 1, 3);
            if ($.cookie('next_sequence') == 2) {
                _util.set_cookie('next_sequence', 2, 3);
            }

        },
        display_hotties: function(json) {
            if (json && json.users && json.users.length) {
                var users = json.users;
                var html = '';
                $("#hotties-pics").html("");
                for (i=0; i < users.length; i++) {
                    html += "<div id='"+users[i].duid+"_"+users[i].pic_num+"' class='user_pic' style='background-image:url("+users[i].pic_src+");'><img src='"+_modal_vars.cdn_domain+"/images/whos_cute_game/ico_circle_check.png' /></div>";
                }
                // if (users.length <= 0) {
                //     $('table.module-white tbody').html('<tr><td><div align="center"><h1>No More Results</h1></div></td></tr>');
                // }
                $("#hotties-pics").append(html);
            }
        },
        refresh_wink_number: function() {
            var wink_string = '';
            if (data.wink_count > 0) {
                wink_string = data.wink_count+' wink'+(data.wink_count > 1 ? 's' : '');
            } else {
                wink_string = 'winks';
            }
            $('#number_of_winks').html(wink_string);
        },
        add_duids: function() {
            $("#hotties-pics .user_pic").each(function(index, el) {
                var id_picnum = $(el).attr('id');
                if ($(el).hasClass('selected')) {
                    data.hot_duids.push(parseInt(id_picnum, 10)); 
                }
            });
        },
        send_winks: function() {
            for(var x=0; x<data.hot_duids.length && x<10; x++) {
                $.ajax({
                    url: '/main.php',
                    async: false,
                    type: 'POST',
                    // NOTE: this module uses the new apis
                    data: { a:'msg.send_wink', fduid:data.hot_duids[x] }
                });
            }
        }
    };

    this.addInitializer(function() {
        data.init();

        // binds for setting up hotties modal
        self.vent.on(self.moduleName+":setup_hotties_modal", events.setup_hotties_modal, this);
    });
});

